<template>
	<div class="ReModeration mb-3" v-if="ApiData[0]"
		v-loading.fullscreen.lock="$GVO.fullscreenLoading"
		element-loading-text="Загрузка данных..."
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)"
	>
		<div class="row align-items-center mx-0">
			<h4 class="mr-2 mb-0">Модерация объекта</h4>
			<div class="bntGroup mr-2 " v-if="this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.ObjModerator == 1 || ApiData[0].can_moderation">						
				<button type="button" class="btn no-border btn-icon btn-fab btn-primary btn-simple" @click="GoToEdit()"><i class="d-inline-block tim-icons icon-pencil"></i></button>
			</div>		
			<span class="badge badge-success mr-2" style="font-size: 12px;" v-if="ApiData[0].moderation_status_id != '' && ApiData[0].moderation_status_id == 2">Объект принят</span>
			<span class="badge badge-danger mr-2" style="font-size: 12px;" v-if="ApiData[0].moderation_status_id != '' && ApiData[0].moderation_status_id == 3">Объект отклонен </span>
			<span class="badge badge-default mr-2" style="font-size: 12px;" v-if="ApiData[0].moderation_status_id == '' || ApiData[0].moderation_status_id == 1">Объект не проверен </span>
		</div>
		<h4 class="mr-2 mb-0"  v-if="ApiData[0].draft && ApiData[0].draft == true">Модерация недоступна, так как объект в статусе "Черновик"</h4>			
		<div class="" v-if="(this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.ObjModerator == 1 || ApiData[0].can_moderation) && ApiData[0].moderation_status_id != 3 && ApiData[0].moderation_status_id != 2 && (!ApiData[0].draft) ">
			
			<form action="" >

				<div class="col-md-12 checkbox-radios">
					<p >Выберите из списка ниже ошибки, найденные в объекте</p>
					<div class="form-check" v-for="(item,index) in masModerationList" :key="index">
						<label :for="item.id" class="form-check-label">
							<input
								class="form-check-input"
								:value="item.name"
								:id="item.id"
								:checked="item.checked" 
								type="checkbox"
								v-model="masErrors"
							/>{{item.name}}
							<span class="form-check-sign"></span>
						</label>
					</div>

				</div>

				<textarea 
				class="form-control my-3"
				placeholder="Комментарий"
				v-model="comment">	
				</textarea>	
				<p class="text-danger" v-if="ApiData[0].zipal_error!='' && ApiData[0].zipal_error!=null"><i class="tim-icons text-danger icon-alert-circle-exc mr-2"></i>При наличии ошибок от Zipal объект будет отклонен</p>

				<el-select
					class="col-md px-0 mb-2 select-primary"
					v-model="moderation_status" 
					clearable
					placeholder="Выберите статус модерации"
					size="large"
				>
					<el-option
						class="select-primary"
						v-for="status in masModerationStatus"
						:key="status.value"
						:label="status.label"
						:value="status.value"
					>
					</el-option>
				</el-select>
				<base-button class="btn-group"
				type="success" simple @click="Moderate()" v-if="this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.ObjModerator == 1 || ApiData[0].can_moderation"
				>Модерировать объект</base-button>

			</form>
		</div>

		<div class="ReModerationErrors" v-if="(masModeratedObjs && masModeratedObjs.comment!='') || masErrorsToFix.length > 0">
			<h4 class="text-danger" v-if="ApiData[0].moderation_status_id == 3"><i class="tim-icons text-danger icon-alert-circle-exc mr-2"></i>Исправьте ошибки и отправьте объект на повторную модерацию</h4>
			<!-- <h4 class="text-primary mb-1 mt-3 previousErrors" v-if="(ApiData[0].moderation_status_id == 3 || ApiData[0].moderation_status_id == 1) && masErrors.length != 0">Предыдущие ошибки</h4> -->
			<ul class="list-unstyled result-marker mb-3" v-if="ApiData[0].moderation_status_id == '' || (ApiData[0].moderation_status_id != 1 && ApiData[0].moderation_status_id != 2)">
				<!-- <li v-for="(item,index) in masErrorsToFix">{{ item.name }}</li> -->
				<li v-for="(item,index) in masErrorsToFix" :key="index">{{ item }}</li> <!-- было так пока кто-то что-то не сломал, бэкэндеры-->
			</ul>
			
			<p v-if="ApiData[0].moderation_status_id == '' || (ApiData[0].moderation_status_id != 1 && ApiData[0].moderation_status_id != 2) && masModeratedObjs.comment!=''"><span class="font-weight-bold"> Комментарий: </span> {{ masModeratedObjs.comment }}</p>
			
		</div>
		<!-- <h4 class="text-danger" v-if="(ApiData[0].moderation_status_id == 3) && (this.$GVO.my_profile.adm == '' && this.$GVO.my_profile.ObjModerator != 1)"><i class="tim-icons text-danger icon-alert-circle-exc mr-2"></i>Отредактируйте объект и только затем отправьте на модерацию по кнопке ниже</h4> -->
		<!-- <base-button class="btn-group"
			type="primary" 
			simple 
			@click="sendToModerator()"
			v-if="(ApiData[0].moderation_status_id == 3) && (this.$GVO.my_profile.adm == '' && this.$GVO.my_profile.ObjModerator != 1)"
		>Отправить на модерацию</base-button> -->
		<base-button class="btn-group"
			type="primary" 
			simple 
			@click="GoToEditObject(ApiData[0].id)"
			v-if="(ApiData[0].moderation_status_id == 3) && (this.$GVO.my_profile.adm == '' && this.$GVO.my_profile.ObjModerator != 1)"
		>Отредактировать объект и отправить на модерацию</base-button>
		<base-button class="btn-group"
			type="primary" 
			simple 
			@click="returnObjToModerator()"
			v-if="(ApiData[0].moderation_status_id == 2) && (this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.ObjModerator == 1 || ApiData[0].can_moderation) && (ApiData[0].draft!=true)"
		>Вернуть на модерацию</base-button>
		
		
		<!-- Статусы модерации: 
			1 Не проверен
			2 Принят
			3 Отклонен
		-->

		<!-- <div v-if="this.$GVO.my_profile.adm == 1">
			<ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Модерировать объект" />
		</div>   -->
				

	</div>
</template>
<script>
// import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
import { Select, Option, Tooltip, Button,  } from 'element-ui';
// import {eventEmitter} from "src/plugins/globalComponents.js";

export default {
	name: 'ReModeration',
	components: {
		// ReFormPrinter,
		[Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,

	},
	props: {
		// objData: Object,
		
	},
	data() {
		return {
			ApiData: [],
			comment: '',
			masErrors: [],
			moderation_status: '',
			masModerationStatus: [],
			masModerationList: [],
			masModeratedObjs: {},
			masErrorsToFix: [],
			fullscreenLoading: false,
			
		};
	},
	watch: {
		
	},
	computed: {
	
	},
	methods: {
		getModerationList(){
			//console.log('getApiData = MyObj.GET', this.$route.params.object_id);
			// this.ApiData = [];

			this.$GVO.ApiCall('MODERATION_LIST.GET',{flt:{'id':'true','c2p':100, act: 1}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.masModerationList = objApi.data;
					}
				}else{
					this.masModerationList = [];
					
				}
			}).catch(errorObjApi => {this.masModerationList = []; console.error(errorObjApi); });
		},
		getApiData(){
			//console.log('getApiData = MyObj.GET', this.$route.params.object_id);
			this.ApiData = [];

			this.$GVO.ApiCall('MyObj.GET',{flt:{'id':this.$route.params.object_id}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
						
					}
				}else{
					this.ApiData = [];
					
				}
			}).catch(errorObjApi => {this.ApiData = []; console.error(errorObjApi); });
		},
		moderationStatusSend(data){
			// this.$emit('loadmore', strType);
			// eventEmitter.$emit('moderationStatus', moderation_status);
			this.$emit('moderationStatus', data);
			// console.log('data', data);
		},	
		Moderate(){
			if(this.moderation_status !='') {
				if(this.moderation_status==3 && this.comment=='' && this.masErrors.length==0){
					//alert('При отклонении необходимо написать комментарий или выбрать причину');
					this.$GVO.showAlert('Модерация',`<div>При отклонении необходимо написать комментарий или выбрать причину</div>`,'btn btn-info btn-fill');
					return false;
				}
				this.$GVO.ApiCall('MyObj.MODERATE',{flt:{id:this.ApiData[0].id, moderation_status: this.moderation_status, comment: this.comment, errors: JSON.stringify(this.masErrors)},  })
				.then((objApi) => {
					if(objApi.success === true){
						
						this.getErrorsToFix();
						this.getApiData();
						this.openFullScreen1();
						this.moderationStatusSend(this.moderation_status);
						
						// eventEmitter.$emit('moderationStatus', this.moderation_status);
						
					}else{
						
						//alert('Не сохранилось. Возможно у вас нет прав на модерацию');
						this.$GVO.showAlert('Модерация',`<div>Не сохранилось. Возможно у вас нет прав на модерацию</div>`,'btn btn-info btn-fill');
						
					}
				}).catch(errorObjApi => {console.error(errorObjApi); });
			} else {
				//alert('Статус модерации не выбран');
				this.$GVO.showAlert('Модерация',`<div>Статус модерации не выбран</div>`,'btn btn-info btn-fill');
			}

		},
		getErrorsToFix(){
			//console.log('getApiData = MyObj.GET', this.$route.params.object_id);
			this.masModeratedObjs = {};

			this.$GVO.ApiCall('MyObj.GET_MODERATION_ERRORS',{flt:{object_id:this.$route.params.object_id}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.masModeratedObjs = objApi.data[0];
						// console.log('this.masModeratedObjs', this.masModeratedObjs);
						if(this.masModeratedObjs.errors !='' && this.masModeratedObjs.errors !='[]'){
							this.masErrorsToFix = JSON.parse(this.masModeratedObjs.errors);
							
						}
						// if(this.masModeratedObjs.length > 0){
						// 	this.masErrorsToFix = JSON.parse(this.masModeratedObjs.errors);
							
						// }
						// console.log('this.masErrorsToFix', this.masErrorsToFix);
					}
				}else{
					this.masModeratedObjs = {};
					
				}
			}).catch(errorObjApi => {this.masModeratedObjs = {}; console.error(errorObjApi); });
		},
		returnObjToModerator(){
			// console.log('getApiData = MyObj.MODERATE' + " " + this.objData.id);
			this.$GVO.ApiCall('MyObj.MODERATE',{flt:{id:this.ApiData[0].id, moderation_status: 1}})
			.then((objApi) => {
				if(objApi.success === true){
					// console.log(this.objData.id);
					if(objApi.data.length > 0){
						this.ApiData[0].moderation_status_id = this.moderation_status;
						
						// console.log('getApiData = MyObj.MODERATE' + " " + this.objData.moderation_status_id);
					}
					this.masErrorsToFix = [];
					this.masModeratedObjs = {};
					this.getApiData();
					this.moderationStatusSend(1);
					location.reload();
					// this.moderation_status = '';
				}else{
					// objData.moderation_status_id  = ;
					alert('Не сохранилось. Обратитесь к разработчикам');
				}
			}).catch(errorObjApi => {console.error(errorObjApi); });
		},
		// sendToModerator(){
		// 	// сейчас не используется, так как по тычку на кнопку теперь переходим сразу на страницу редактирования объекта
		// 	// console.log('getApiData = MyObj.MODERATE' + " " + this.objData.id);
		// 	this.$GVO.ApiCall('MyObj.UPD_STATUS',{flt:{id:this.ApiData[0].id, moderation_status: 1,}})
		// 	.then((objApi) => {
		// 		if(objApi.success === true){
		// 			// console.log(this.objData.id);
		// 			if(objApi.data.length > 0){
		// 				this.ApiData[0].moderation_status_id = this.moderation_status;
		// 				// console.log('getApiData = MyObj.MODERATE' + " " + this.objData.moderation_status_id);
		// 			}
		// 			this.masErrorsToFix = [];
		// 			this.masModeratedObjs = {};
		// 			// this.getErrorsToFix();
		// 			this.getApiData();
		// 		}else{
		// 			// objData.moderation_status_id  = ;
		// 			alert('Не сохранилось. Обратитесь к разработчикам');
		// 		}
		// 	}).catch(errorObjApi => {console.log(errorObjApi); });
		// },
		
		GoToEdit(){
			location.href = '/data/settings/moderation_list_editor';
		},
		GoToEditObject(obj_id, dealType, objectType){
			location.href = '/data/module/mo/object/'+obj_id+'/edit';
		},
		openFullScreen1() {
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 3000);
		},


		
	},
	mounted() {
		this.$GVO.LoadCatPromise('cat_moderation_status')
			.then((objApi) => {
				if(objApi=== true){
					// this.masTopicTags = []
					for (let i = 0; i < this.$GVO.cats.cat_moderation_status.length; i++) {
						const element = this.$GVO.cats.cat_moderation_status[i];
						if(element.act==1) this.masModerationStatus.push({'value':element.value,'label':element.label, 'id':element.id}); 
						// if(element.act==1) this.objModerationData.moderation_status.options.push({'value':element.value,'label':element.label, 'id':element.id}); 
						
					}
				}
			})
			.catch(errorObjApi => {console.error(errorObjApi); });
		this.getApiData();
		this.getModerationList();
		this.getErrorsToFix();
	}
};
</script>
<style scoped>

.ReModeration >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01B0E0;}
.ReModeration {border: 1px dashed #BA54F5; border-radius: 6px; padding: 15px;}
.ReModeration >>> .form-options-group {width: 100%;}
.ReModeration >>> .form-check {width: 100%;}
.previousErrors {width: 100%; border-top: 1px solid #BA54F5; padding-top: 10px;}
/* .ReModeration >>> .form-group, .mobjectNest >>> #feature {padding-right: 38px!important;} */


</style>
